import { render, staticRenderFns } from "./ClinicDrugStat.vue?vue&type=template&id=3b925b36&scoped=true"
import script from "./ClinicDrugStat.vue?vue&type=script&lang=js"
export * from "./ClinicDrugStat.vue?vue&type=script&lang=js"
import style0 from "./ClinicDrugStat.vue?vue&type=style&index=0&id=3b925b36&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b925b36",
  null
  
)

export default component.exports